export default __webpack_public_path__ + "static/media/ArchiveIcon.de92e49a.svg";